import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import {
  FormContainer,
  FormTitle,
  FormDescription,
  ImageCard,
  ImageFrame,
  ImageOverlay,
  ImageBadge,
  ImageCaption,
  // NEW
  RightColumn,
  VisitCard,
  VisitGrid,
  VisitSection,
  VisitTitle,
  VisitList,
  VisitItem,
} from "./styles"

const ContactForm = () => {
  return (
    <FormContainer>
      <FormTitle>Drop us an Email</FormTitle>
      <FormDescription>We will get back to you in 1-2 working day(s).</FormDescription>

      {/* Wrap both cards so VisitCard can sit at the bottom */}
      <RightColumn>
        <ImageCard>
          <ImageFrame>
            <StaticImage
              src="../../../assets/images/BCA.png"
              alt="Ace Industrial Academy at BCA Braddell Campus"
              layout="fullWidth"
              placeholder="blurred"
              formats={["auto", "webp", "avif"]}
            />
            <ImageOverlay />
            <ImageBadge>Our Campus</ImageBadge>
            <ImageCaption>
              <span>Ace Industrial Academy</span>
              <span>@ BCA Braddell Campus</span>
            </ImageCaption>
          </ImageFrame>
        </ImageCard>

        {/* Hours & Getting Here card pinned to bottom */}
        <VisitCard aria-label="Visitor information">
          <VisitGrid>
            <VisitSection>
              <VisitTitle>Hours</VisitTitle>
              <VisitList>
                <VisitItem><strong>Mon – Fri:</strong> 8:30am – 5:30pm</VisitItem>
                <VisitItem><strong>Sat:</strong> 9:00am – 1:00pm</VisitItem>
                <VisitItem><strong>Sun &amp; PH:</strong> Closed</VisitItem>
              </VisitList>
            </VisitSection>

            <VisitSection data-divider>
              <VisitTitle>Getting Here</VisitTitle>
              <VisitList>
                <VisitItem><strong>Nearest MRT:</strong> Circle Line, Bartley </VisitItem>
                <VisitItem><strong>Bus:</strong> 28, 73, 129, 155, 159, 105, 153, &amp; 93</VisitItem>
                <VisitItem><strong>Parking:</strong> Enter from Bishan St 11 &amp; 13</VisitItem>
              </VisitList>
            </VisitSection>
          </VisitGrid>
        </VisitCard>
      </RightColumn>
    </FormContainer>
  )
}

export default ContactForm
